import React from "react";

const LimitTableColumns = [
    {
        header: "Limits.car",
        name: "car",
        sortProperty: "Car"
    },
    {
        header: "Limits.userName",
        name: "userName",
        sortProperty: "Car"
    },
    {
        header: "Limits.orderDate",
        name: "endDate",
        sortProperty: "EndDate",
        dataType: 'custom',
        render: (item) => {
            const date = item.endDate.substring(0, 10);

            return (
                <>
                    {date}
                </>
            )
        }
    },
    {
        header: "Limits.fuelType",
        name: "fuelType",
        sortProperty: "FuelType"
    },
    {
        header: "Limits.dateLimit",
        name: "dateLimit",
        sortProperty: "DateLimit"
    },
    {
        header: "Limits.totalVolume",
        name: "totalVolume",
        sortProperty: "TotalVolume",
        dataType: "float"
    },
    {
        header: "Limits.publisherName",
        name: "publisherName",
        sortProperty: "PublisherName"
    },
    {
        header: "Limits.mechanicName",
        name: "mechanicName",
        sortProperty: "MechanicName"
    },
    {
        header: "Limits.isFullyUsed",
        name: "isFullyUsed",
        dataType: "boolean",
        sortProperty: "IsFullyUsed"
    }
];

export default LimitTableColumns;